/* jshint esversion: 6 */
window.$ = require('jquery');
require('jquery-datetimepicker/build/jquery.datetimepicker.full.min.js');
require('jquery-form/jquery.form.js');
require('jquery-datetimepicker/build/jquery.datetimepicker.min.css');
require('jquery-ui/ui/widgets/sortable.js');



// WEBPACK FOOTER //
// ./C:/wamp64/www/deporduel/devel/vendor.js